
    <div class="row">
      <div class="col-12">
        <a [id]="id" (click)="this.back.next()"></a>
      </div>
    </div>
  